import { useState, useEffect, useRef } from "react";

function useLongPress(callback: () => void, ms: number = 500) {
  const [startLongPress, setStartLongPress] = useState(false);
  const [isLongPressing, setIsLongPressing] = useState(false);
  const callbackRef = useRef(callback);
  const timerIdRef = useRef<NodeJS.Timeout | undefined>();

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (startLongPress) {
      timerIdRef.current = setTimeout(() => {
        callbackRef.current();
        setIsLongPressing(true);
      }, ms);
    } else {
      clearTimeout(timerIdRef.current!);
      setIsLongPressing(false);
    }

    return () => {
      clearTimeout(timerIdRef.current!);
    };
  }, [ms, startLongPress]);

  const start = (e: MouseEvent | TouchEvent) => {
    if (e) {
      e.preventDefault();
    }
    setStartLongPress(true);
  };

  const stop = () => {
    setStartLongPress(false);
  };

  return {
    isLongPressing,
    onMouseDown: start,
    onTouchStart: start,
    onMouseUp: stop,
    onMouseLeave: stop,
    onTouchEnd: stop,
    onLongPressStart: start,
    onLongPressEnd: stop,
  };
}

export { useLongPress };
